import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEscalatorDowninline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M49.913 42H55a6 6 0 1 1 0 12h-6.432a12 12 0 0 1-9.163-4.252l-22.263-26.33A4 4 0 0 0 14.087 22H9a6 6 0 1 1 0-12h6.432a12 12 0 0 1 9.163 4.252l22.263 26.33A4 4 0 0 0 49.913 42z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 33,
				cy: 7,
				r: 3
			}),
			/* @__PURE__ */ _jsx("path", { d: "M36 27.5V14a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v6.5M21 51L11 41" }),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M13 51h8v-8"
			})
		]
	})
});
export default SvgEscalatorDowninline;
